import {GlobalFilterRuleListItem} from '../../../integrated-client/models/';

export type GlobalFiltersItemsList = Array<GlobalFilterRuleListItem>;

export class ResultsData {
  items: GlobalFilterRuleListItem[]
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }
}
